export function register() {
  if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((reg) => {
          // Check for updates periodically
          setInterval(() => reg.update(), 60 * 60 * 1000); // every hour

          reg.onupdatefound = () => {
            const worker = reg.installing;
            if (!worker) return;

            worker.onstatechange = () => {
              if (worker.state === "activated" && navigator.serviceWorker.controller) {
                // New version available — notify user
                console.log("New version available. Refresh to update.");
              }
            };
          };
        })
        .catch((err) => console.error("SW registration failed:", err));
    });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister());
  }
}
